

function ninjaGridItemCtrl ($timeout, $filter, $scope) {
    var $ctrl = this;
    $ctrl.formatter = function (value, type, viewDisplayAs) {
        const hasInternalTextOnly = /!!(.*?)!!/g;
        const hasContractTextOnly = /{{(.*?)}}/g;
        if (type == 'time') {
            return $filter('date')(value, "shortTime");
        } else if (type == 'timepicker') {
            return $filter('date')(value, "shortTime");
        } else if (type == 'date') {
            return $filter('date')(value, "fullDate");
        }
        else {
            if (typeof value === 'string') {
                if(hasInternalTextOnly.test(value)) {
                    value = value.replace(hasInternalTextOnly, (match, $1) => {
                        return `<span class="highlight-yellow">${$1}</span>`
                    });
                }
                if(hasContractTextOnly.test(value)) {
                    value = value.replace(hasContractTextOnly, (match, $1) => {
                        return `<span class="highlight-light-blue">${$1}</span>`
                    });
                }
                return value;
            } else if (typeof value === 'number') {
                if(viewDisplayAs === 'currency') {
                    const formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                      
                        // These options are needed to round to whole numbers if that's what you want.
                        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                      });
                    
                    return formatter.format(value)
                } else {
                    return value;
                }
            } /* else if (typeof value === 'object') {  // this is a first attempt at showing a nested object property in the grid
              return value[viewDisplayAs];
            } */
              else {
                return value;
            }
        }
    };
    
    $ctrl.deleteItem = function() {
        $ctrl.onDeleteItem({$itemIndex: this.itemIndex});
    };

    // $ctrl.details = function(item) {
    //   console.log(item);
    //   $ctrl.onDetails(item);
    // }
    
    $ctrl.doneEditing = function(item){
        delete item.isEditing;
        delete item.clickedField;
    };
    
    $ctrl.editItem = function(item, clickedField) {
        $timeout(function(){
            item.isEditing = true;
            item.clickedField = {};
            item.clickedField[clickedField] = true;
        },0);
    };
    
    $ctrl.arrowKeyOut = function(item, event, currentField){
        if (event.keyCode == 38) {
            $ctrl.doneEditing(item);
            $ctrl.onArrowKeyOut({item: item, keyCode: 'up', currentField: currentField});
        }
        if (event.keyCode == 40) {
            $ctrl.doneEditing(item);
            $ctrl.onArrowKeyOut({item: item, keyCode: 'down',  currentField: currentField});
        }
    };

    $ctrl.detailBlur = function (item, event, key, fieldDef) {

        if (fieldDef && fieldDef.type && fieldDef.type === 'number') {
          item[key] = parseFloat(item[key])
        }
        var relatedTarget = event.relatedTarget || event.explicitOriginalTarget;
        if (relatedTarget == null || relatedTarget == undefined || event.target.parentElement.parentElement != relatedTarget.parentElement.parentElement ) {
            $timeout(function(){
                delete item.isEditing;
                delete item.clickedField;
            }, 0);
            
        } 
    };
    
    $ctrl.sort = function (startIndex, insertIndex) {
        $ctrl.onSort({startIndex: startIndex, insertIndex: insertIndex});
    };
    
}

ninjaGridItemCtrl.$inject = ['$timeout', '$filter', '$scope'];

var ninjaGridItem = {
    template: require('!raw!jade-html!./ninjaGridItem.jade'),
    controller: ninjaGridItemCtrl,
    transclude: true,
    bindings: {
        item: '<',
        itemIndex: '@',
        fields: '<',
        onDeleteItem: '&',
        onEditItem: '&',
        onUpdateItem: '&',
        onCreateItem: '&',
        onArrowKeyOut: '&',
        showDetailsLink: '=',
        onDetails: '&',
        onSort: '&'
    }
};

export default ninjaGridItem;


// WEBPACK FOOTER //
// ./app/common/widgets/ninjaGrid/ninjaGridItem.js